<template>
  <div class="app-network-container">
    <div class="app-network-select">
      <label class="label">
        Redes
        <span>*</span>
      </label>
      <b-dropdown
        class="select-content"
        v-model="model"
        aria-role="list"
        max-height="250"
        scrollable
        multiple
      >
        <button type="button" slot="trigger">
          <p>Redes selecionadas: [{{ model.length }}]</p>
          <b-icon icon="menu-down"></b-icon>
        </button>

        <b-dropdown-item
          :value="network.id"
          v-for="network in networks"
          :key="network.id"
          aria-role="listitem"
        >
          <span>{{ network.name }}</span>
        </b-dropdown-item>
      </b-dropdown>
      <div v-if="errors && errors.length" class="error">
        <span>Deve selecionar pelo menos uma rede</span>
      </div>
    </div>
    <b-checkbox @input="selectAllNetworks($event)" class="select-all"
      >Selecionar todas as redes</b-checkbox
    >
  </div>
</template>

<script>
import NetworkService from '../../../services/network.service';

export default {
  name: 'app-network-select',
  model: {
    prop: 'model',
    event: 'select',
  },
  props: {
    model: {
      default: () => [],
    },
    errors: {
      default: () => {},
    },
  },
  data: () => {
    return {
      networks: [],
    };
  },
  methods: {
    load() {
      NetworkService.get({ paginate: false })
        .then(({ data }) => (this.networks = data))
        .catch(() => this.toastify('Erro ao carregar Redes.', 'error'));
    },
    updateSelf(networks) {
      this.$emit('select', networks);
    },
    selectAllNetworks(e) {
      if (e) {
        const network_ids = this.networks.map((network) => network.id);
        this.$emit('select', network_ids);
      } else {
        this.$emit('select', []);
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.app-network-container {
  .app-network-select {
    margin: 12px 0;

    button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex: 0 25%;
      padding: 5px;
      padding-left: 10px;
      height: 38px;
      border: none;
      background: var(--color-primary);
      color: #fff;
      border-radius: 8px;
      outline: 0;
      cursor: pointer;
      transition: background 0.2s ease-in-out;

      &:hover {
        background: var(--color-primary-shade);
      }

      p {
        position: relative;
        top: 5px;
      }
    }

    label {
      display: block;
      text-transform: uppercase;
      font-size: 0.9em;
      margin-bottom: 0.5em;

      > span {
        color: var(--color-danger);
        font-size: 0.9em;
        position: relative;
        top: -3px;
        left: -2px;
      }
    }

    .dropdown-content {
      a.is-active {
        background-color: var(--color-primary-shade) !important;
      }
    }

    .error {
      margin-top: 5px;
      font-size: 0.8em;
      color: #ff6363;
    }
  }
}
</style>
